import { createAsyncThunk } from "@reduxjs/toolkit";
import { updatePostFields } from "../../../pages/auth/utils/firebase/userOperations";

export const updatePost = createAsyncThunk(
  "posts/updatePost",
  async ({ postId, updates }, { rejectWithValue }) => {
    try {
      const updated = await updatePostFields(postId, updates);
      return updated;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
